import { render, staticRenderFns } from "./ServicesTab.vue?vue&type=template&id=3318ad14&scoped=true&"
import script from "./ServicesTab.vue?vue&type=script&lang=js&"
export * from "./ServicesTab.vue?vue&type=script&lang=js&"
import style0 from "./ServicesTab.vue?vue&type=style&index=0&id=3318ad14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3318ad14",
  null
  
)

export default component.exports